module.exports = __webpack_public_path__ + "media/cement_blocks_1.e213b31c.wav";